var React = require('react');

function IcoDestination (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"31.82","cy":"35","r":"24.5","fill":"#c4c4c4"}));
}

IcoDestination.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 63.64 70"};

module.exports = IcoDestination;

IcoDestination.default = IcoDestination;
